export default __webpack_public_path__ + "static/media/menu8.0c533f2d.png";